import { render, staticRenderFns } from "./NavigationProfile.vue?vue&type=template&id=5f0c9bbc&"
import script from "./NavigationProfile.controller.js?vue&type=script&lang=js&"
export * from "./NavigationProfile.controller.js?vue&type=script&lang=js&"
import style0 from "./NavigationProfile.styles.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports